import {
  Globe,
  Mail,
  MessageCircle,
  MessageSquare,
  Facebook,
  Instagram,
  Youtube,
  FileText,
  type LucideIcon,
} from 'lucide-react';

/**
 * 渠道 → 图标 + 中文名。**工厂端这一份跟内部后台的 `CHANNEL_LABELS` 是两份。**
 *
 * 内部那份是纯文字表(业务员看得懂 key 本身),工厂端要图标:
 * 列表行上「这条是从哪来的」得一眼看出来,而工厂老板读不出
 * `wa` / `messenger` / `site` 这几个词的差别 —— 图标是他唯一能扫的东西。
 *
 * 认不出来的 key 给一个中性图标 + 原样显示,不给「其他」——
 * 「其他」会把一个我们没接过的新渠道藏起来。
 */
export interface ChannelView {
  label: string;
  icon: LucideIcon;
}

const CHANNELS: Record<string, ChannelView> = {
  site: { label: '独立站', icon: Globe },
  'site-form': { label: '独立站', icon: Globe },
  email: { label: '邮件', icon: Mail },
  'b-email-reply': { label: '邮件', icon: Mail },
  wa: { label: 'WhatsApp', icon: MessageCircle },
  whatsapp: { label: 'WhatsApp', icon: MessageCircle },
  wechat: { label: '微信', icon: MessageSquare },
  messenger: { label: 'Messenger', icon: MessageCircle },
  fb: { label: 'Facebook', icon: Facebook },
  ig: { label: 'Instagram', icon: Instagram },
  youtube: { label: 'YouTube', icon: Youtube },
  customs: { label: '海关数据', icon: FileText },
  manual: { label: '手动录入', icon: FileText },
};

export function channelView(key: string | null | undefined): ChannelView {
  if (!key) return { label: '', icon: MessageSquare };
  return CHANNELS[key] ?? { label: key, icon: MessageSquare };
}
